import Component from "./UniCard";
import Bottom from "./components/Bottom/UniCardBottom";
import ButtonsView from "./components/ButtonsView/UniCardButtonsView";
import Media from "./components/Media/UniCardMedia";
import Text from "./components/Text/UniCardText";

interface IUniCardExtention {
    Media: typeof Media;
    Text: typeof Text;
    Bottom: typeof Bottom;
    ButtonsView: typeof ButtonsView;
}

export const UniCard: typeof Component & IUniCardExtention = Object.assign(
    Component,
    {
        Media,
        Text,
        Bottom,
        ButtonsView,
    },
);

export type {
    UniCardProps,
    UniCardSizes,
    UniCardWithCustomSize,
} from "./types";
